const AuthRoutes = {
  login: 'login',
  register: 'register',
  forgotPassword: 'forgotpassword',
  updateProfile: 'users/updateProfile',
  checkCoupon: 'coupons/find-by-code',
  checkExists: 'check-exists'
};

export default AuthRoutes